import React, { ReactNode } from 'react';
import { Accordion } from '@next-components/accordion';
import { OrderAccordionWrapper } from './OrderAccordion.styled';

export interface IOrderAccordianProps {
  label: string;
  isOpen?: boolean;
  isDisabled?: boolean;
  children: ReactNode;
  className?: string;
}

export const OrderAccordion = (props: IOrderAccordianProps) => (
  <OrderAccordionWrapper className="OrderAccordionWrapper">
    <Accordion
      primaryLabel={props.label}
      isOpen={props.isOpen}
      isDisabled={props.isDisabled}
      nextAccordion
      className={`small newNext ${props.className ?? ''}`}
      greyMode>
      {props.children}
    </Accordion>
  </OrderAccordionWrapper>
);

OrderAccordion.defaultProps = {
  isDisabled: false,
};
